export const getTemperature = (tempID: number) => {
	switch (tempID) {
	case 2:
		return 'CHILLED';
	case 3:
		return 'FROZEN';
	case 1:
	default:
		return 'AMBIENT';
	}
}
